(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.swipe-modal[data-v-31c69cef]{position:fixed;top:auto;box-sizing:border-box;width:100vw;max-width:100vw;height:100dvh;max-height:100dvh;padding:0;margin:0;overflow:hidden;border:none}.swipe-modal[data-v-31c69cef]::backdrop{background-color:#00000080;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}.swipe-modal-content[data-v-31c69cef]{width:100%;height:100%}.swipe-modal-content>.panel[data-v-31c69cef]{max-height:calc(100dvh - 36px);overflow-y:scroll}.modal-style[data-v-31c69cef]{box-sizing:border-box;width:100%;color:#fff;background-color:#1d1b20;border-radius:1rem 1rem 0 0}@media (prefers-color-scheme: light){.modal-style[data-v-31c69cef]{color:#000;background-color:#f7f2fa;box-shadow:0 1px 4px #0000005e}}.swipe-modal-drag-handle-wrapper[data-v-31c69cef]{position:relative;top:0;flex-shrink:0;height:36px;cursor:grab}.swipe-modal-drag-handle-wrapper[data-v-31c69cef]:active{cursor:grabbing}.swipe-modal-drag-handle[data-v-31c69cef]{position:absolute;left:50%;width:32px;height:4px;margin:16px 0;content:"";background-color:#ccc;border-radius:2px;transform:translate(-50%)}')),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { getCurrentInstance as F, ref as S, watch as M, nextTick as N, computed as D, defineComponent as I, onMounted as L, onUnmounted as O, openBlock as _, createElementBlock as U, createElementVNode as Y, unref as h, renderSlot as B, createCommentVNode as H, pushScopeId as G, popScopeId as J } from "vue";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const W = (t) => typeof t < "u";
function z(t) {
  return JSON.parse(JSON.stringify(t));
}
function X(t, n, o, r = {}) {
  var e, a, m;
  const {
    clone: d = !1,
    passive: s = !1,
    eventName: P,
    deep: f = !1,
    defaultValue: y,
    shouldEmit: E
  } = r, p = F(), V = o || (p == null ? void 0 : p.emit) || ((e = p == null ? void 0 : p.$emit) == null ? void 0 : e.bind(p)) || ((m = (a = p == null ? void 0 : p.proxy) == null ? void 0 : a.$emit) == null ? void 0 : m.bind(p == null ? void 0 : p.proxy));
  let v = P;
  v = v || `update:${n.toString()}`;
  const g = (c) => d ? typeof d == "function" ? d(c) : z(c) : c, b = () => W(t[n]) ? g(t[n]) : y, A = (c) => {
    E ? E(c) && V(v, c) : V(v, c);
  };
  if (s) {
    const c = b(), w = S(c);
    let i = !1;
    return M(
      () => t[n],
      (l) => {
        i || (i = !0, w.value = g(l), N(() => i = !1));
      }
    ), M(
      w,
      (l) => {
        !i && (l !== t[n] || f) && A(l);
      },
      { deep: f }
    ), w;
  } else
    return D({
      get() {
        return b();
      },
      set(c) {
        A(c);
      }
    });
}
const C = "cubic-bezier(0.2, 0.0, 0, 1.0)", $ = ({ scopeName: t }) => {
  const n = (e) => getComputedStyle(document.documentElement).getPropertyValue(`--${t}-${e}`);
  return {
    setCssVar: ({ name: e, value: a, fallback: m }) => {
      document.documentElement.style.setProperty(`--${t}-${e}`, a), m == null || m(
        e,
        n(e)
      );
    },
    getCssVar: n,
    removeCssVar: (e) => {
      document.documentElement.style.removeProperty(`--${t}-${e}`);
    }
  };
}, k = ({
  scopeName: t,
  positionStatus: n,
  props: o,
  refs: {
    modalRef: r
  }
}) => {
  const {
    getCssVar: e,
    setCssVar: a
  } = $({ scopeName: t });
  return {
    cancelAnim: () => {
      if (!r.value)
        return;
      const P = () => n.value === "snap" ? o.snapPoint ? e("snapPointPosition") : "0%" : n.value === "full" ? "0%" : "-100%";
      r.value.animate(
        [
          { bottom: e("bottom") },
          {
            bottom: P()
          }
        ],
        {
          duration: 300,
          easing: C
        }
      ).onfinish = () => {
        a({
          name: "movementAmountY",
          value: "0"
        }), a({
          name: "bottom",
          value: P()
        });
      };
    },
    moveToSnapPointAnim: () => {
      r.value && o.snapPoint && (r.value.animate(
        [
          { bottom: e("bottom") },
          {
            bottom: e("snapPointPosition")
          }
        ],
        {
          duration: 300,
          easing: C
        }
      ).onfinish = () => {
        a({
          name: "movementAmountY",
          value: "0"
        }), a({
          name: "bottom",
          value: e("snapPointPosition")
        }), n.value = "snap";
      });
    },
    moveToFullScreenAnim: () => {
      r.value && (r.value.animate(
        [
          { bottom: e("bottom") },
          {
            bottom: "0%"
          }
        ],
        {
          duration: 300,
          easing: C
        }
      ).onfinish = () => {
        a({
          name: "movementAmountY",
          value: "0"
        }), a({
          name: "bottom",
          value: "0%"
        }), n.value = "full";
      });
    }
  };
}, j = ({
  scopeName: t,
  positionStatus: n,
  props: o,
  refs: { modalRef: r },
  vModel: e
}) => {
  const {
    getCssVar: a,
    setCssVar: m
  } = $({ scopeName: t }), {
    cancelAnim: d,
    moveToSnapPointAnim: s,
    moveToFullScreenAnim: P
  } = k({
    scopeName: t,
    positionStatus: n,
    props: o,
    refs: {
      modalRef: r
    }
  }), f = S(!1), y = S(0);
  return {
    isMouseDown: f,
    handlePointerDown: ({
      mouseEvent: v,
      touchEvent: g,
      eventType: b
    }) => {
      b === "mouse" ? y.value = v.y : y.value = g.touches[0].clientY, f.value = !0;
    },
    handlePointerMove: ({
      mouseEvent: v,
      touchEvent: g,
      eventType: b
    }) => {
      var A, c;
      if (f.value && (m(b === "mouse" ? {
        name: "movementAmountY",
        value: (y.value - v.y).toString()
      } : {
        name: "movementAmountY",
        value: (y.value - g.touches[0].clientY).toString()
      }), !(Number(a("movementAmountY")) > 0 && n.value === "full" || (((A = r.value) == null ? void 0 : A.getBoundingClientRect().top) || 0) < 0) && !(!o.isFullScreen && Number(a("movementAmountY")) > 0))) {
        if ((c = r.value) == null || c.style.setProperty("user-select", "none"), n.value === "snap") {
          m({
            name: "bottom",
            value: `calc(${a("snapPointPosition")} + ${a("movementAmountY")}px)`
          });
          return;
        }
        m({
          name: "bottom",
          value: `calc(0% + ${a("movementAmountY")}px)`
        });
      }
    },
    handlePointerUp: () => {
      var v;
      if (f.value = !1, (v = r.value) == null || v.style.removeProperty("user-select"), Math.abs(Number(a("movementAmountY"))) > 36) {
        if (Number(a("movementAmountY")) < 0)
          switch (n.value) {
            case "full":
              return o.snapPoint ? s() : o.isPersistent ? d() : e.value = !1;
            case "snap":
              return o.isPersistent ? d() : e.value = !1;
            default:
              return;
          }
        switch (n.value) {
          case "snap":
            return o.isFullScreen ? P() : d();
          default:
            return;
        }
      }
      return d();
    }
  };
}, T = (t) => {
  if (t === "reset") {
    document.documentElement.style.removeProperty("overflow"), document.documentElement.style.removeProperty("overscroll-behavior-y");
    return;
  }
  let n = window, o, r, e;
  document.defaultView ? (n = document.defaultView, o = n.scrollX, r = n.scrollY) : (e = document.documentElement, o = e.scrollLeft, r = e.scrollTop), document.documentElement.style.overflow = t, document.documentElement.style.overscrollBehaviorY = t === "auto" ? "auto" : "none", n.scrollTo(o, r);
}, q = (t) => (G("data-v-31c69cef"), t = t(), J(), t), K = /* @__PURE__ */ q(() => /* @__PURE__ */ Y("div", { class: "swipe-modal-drag-handle" }, null, -1)), Q = /* @__PURE__ */ I({
  __name: "SwipeModal",
  props: {
    isBackdrop: { type: Boolean, default: !0 },
    isDragHandle: { type: Boolean, default: !0 },
    isFullScreen: { type: Boolean, default: !0 },
    isPersistent: { type: Boolean, default: !1 },
    isScrollLock: { type: Boolean, default: !0 },
    modelValue: { type: Boolean, default: !1 },
    snapPoint: { default: void 0 }
  },
  emits: ["update:modelValue"],
  setup(t, { emit: n }) {
    const o = t, r = n, e = Math.random().toString(36).substring(2) + Math.random().toString(36).substring(2), {
      getCssVar: a,
      setCssVar: m,
      removeCssVar: d
    } = $({
      scopeName: e
    }), s = S(null), P = S(null), f = X(o, "modelValue", r), y = S("close"), {
      cancelAnim: E
    } = k({
      scopeName: e,
      positionStatus: y,
      props: o,
      refs: {
        modalRef: s
      }
    }), {
      isMouseDown: p,
      handlePointerDown: V,
      handlePointerMove: v,
      handlePointerUp: g
    } = j({
      vModel: f,
      scopeName: e,
      positionStatus: y,
      props: o,
      refs: {
        modalRef: s,
        panelRef: P
      }
    }), b = (i) => {
      if (o.isBackdrop && i.target === i.currentTarget) {
        if (o.isPersistent)
          return E();
        f.value = !1;
      }
    }, A = (i) => {
      i.stopPropagation();
    }, c = () => {
      var l;
      if (!s.value)
        return;
      o.isBackdrop ? s.value.showModal() : s.value.show(), (l = s.value) == null || l.style.setProperty("visibility", "visible"), navigator.userAgent.toLowerCase().includes("firefox") || navigator.userAgent.toLowerCase().includes("mozilla") || s.value.animate([
        { opacity: 0 },
        { opacity: 1 }
      ], {
        duration: 200,
        pseudoElement: "::backdrop",
        easing: C
      }), s.value.animate(
        [
          {
            bottom: "-100%"
          },
          {
            bottom: a("snapPointPosition")
          }
        ],
        {
          duration: 300,
          easing: C
        }
      ).onfinish = () => {
        y.value = o.snapPoint ? "snap" : "full", m({
          name: "bottom",
          value: a("snapPointPosition")
        }), o.isScrollLock && T("hidden");
      };
    }, w = () => {
      if (!s.value)
        return;
      navigator.userAgent.toLowerCase().includes("firefox") || navigator.userAgent.toLowerCase().includes("mozilla") || s.value.animate([
        { opacity: 1 },
        { opacity: 0 }
      ], {
        duration: 300,
        pseudoElement: "::backdrop",
        easing: C
      }), s.value.animate(
        [
          {
            bottom: a("bottom")
          },
          {
            bottom: "-100%"
          }
        ],
        {
          duration: 300,
          easing: C
        }
      ).onfinish = () => {
        var l, u, x;
        m({
          name: "bottom",
          value: "-100%"
        }), y.value = "close", p.value = !1, (l = s.value) == null || l.close(), (u = s.value) == null || u.style.setProperty("display", "initial"), (x = s.value) == null || x.style.setProperty("visibility", "hidden"), T("reset");
      };
    };
    return M(
      () => f.value,
      (i) => {
        i ? c() : w();
      }
    ), M(
      () => o.isScrollLock,
      (i) => {
        T(i ? "hidden" : "auto");
      }
    ), M([() => o.snapPoint, () => P.value], ([i, l]) => {
      let u;
      i ? i === "auto" ? u = `calc(${(l == null ? void 0 : l.getBoundingClientRect().height) || 0}px + 36px - 100%)` : u = `calc(${i} - 100%)` : u = "0px", m({
        name: "snapPointPosition",
        value: u
      });
    }, {
      immediate: !0
    }), m({
      name: "bottom",
      value: "-100%"
    }), m({
      name: "movementAmountY",
      value: "0"
    }), L(() => {
      s.value && (s.value.style.setProperty("bottom", `var(--${e}-bottom)`), s.value.addEventListener("cancel", () => {
        f.value = !1;
      }), f.value || (s.value.style.setProperty("display", "initial"), s.value.style.setProperty("visibility", "hidden")));
    }), O(() => {
      d("bottom"), d("movementAmountY"), d("snapPointPosition"), s.value && s.value.removeEventListener("cancel", () => {
      });
    }), (i, l) => (_(), U("dialog", {
      ref_key: "modalRef",
      ref: s,
      class: "swipe-modal modal-style",
      onClick: b
    }, [
      Y("div", {
        tabindex: "-1",
        class: "swipe-modal-content",
        onClick: A
      }, [
        Y("div", {
          class: "swipe-modal-drag-handle-wrapper",
          onMousedown: l[0] || (l[0] = (u) => h(V)({
            mouseEvent: u,
            eventType: "mouse"
          })),
          onMousemove: l[1] || (l[1] = (u) => h(v)({
            mouseEvent: u,
            eventType: "mouse"
          })),
          onMouseup: l[2] || (l[2] = //@ts-ignore
          (...u) => h(g) && h(g)(...u)),
          onTouchstart: l[3] || (l[3] = (u) => h(V)({
            touchEvent: u,
            eventType: "touch"
          })),
          onTouchmove: l[4] || (l[4] = (u) => h(v)({
            touchEvent: u,
            eventType: "touch"
          })),
          onTouchend: l[5] || (l[5] = //@ts-ignore
          (...u) => h(g) && h(g)(...u))
        }, [
          i.isDragHandle ? B(i.$slots, "drag-handle", { key: 0 }, () => [
            K
          ], !0) : H("", !0)
        ], 32),
        Y("div", {
          ref_key: "panelRef",
          ref: P,
          class: "panel"
        }, [
          B(i.$slots, "default", {}, void 0, !0)
        ], 512)
      ])
    ], 512));
  }
}), Z = (t, n) => {
  const o = t.__vccOpts || t;
  for (const [r, e] of n)
    o[r] = e;
  return o;
}, ee = /* @__PURE__ */ Z(Q, [["__scopeId", "data-v-31c69cef"]]);
export {
  ee as SwipeModal,
  ee as default
};
